import { memo } from 'react';

import { Text } from '../../design-system/typography';

// Memoized time display component to prevent unnecessary re-renders
export const TimeDisplay = memo(({ currentTime, duration }: { currentTime: number; duration: number }) => {
	// Format time in MM:SS format
	const formatTime = (timeInSeconds: number) => {
		const minutes = Math.floor(timeInSeconds / 60);
		const seconds = Math.floor(timeInSeconds % 60);
		return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
	};

	return (
		<Text fontSize="md" role="status" aria-label={`Current time: ${formatTime(currentTime)} of ${formatTime(duration)}`}>
			{formatTime(currentTime)}
			{Number.isFinite(duration) && duration > 0.01 && ` / ${formatTime(duration)}`}
		</Text>
	);
});

TimeDisplay.displayName = 'TimeDisplay';
